import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/[locale]/orders/orders-list.tsx");
